import React from "react";
import { HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import logo from "../../assets/icons/logo-sm.png";
import "./Footer.css";
import { FaTelegram, FaWhatsapp } from "react-icons/fa";

const Footer = (props) => {

  const onClickWhatsapp = () => {
    const url = `https://whatsapp.com/channel/0029Vb5pLuREFeXcahDCBx2m`;
    window.open(url, "_blank");
  };

  const onClickTelegram = () => {
    const url = "https://t.me/+vy3uQbpfqCk0Nzgx"; 
    window.open(url, "_blank");
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Sección Superior */}
        <div className="footer-top">
          {/* Logo Centrado */}
          <div className="footer-logo">
            <img src={logo} alt="SYT Rocstar" className="logo-img" />
          </div>

          {/* Contacto */}
          <div className="footer-section">
            <h3 className="section-title-b">Contacto</h3>
            <div className="contact-info">
              <div className="contact-item">
                <HiOutlineMail className="contact-icon" />
                <span>soporte@rocstar.tv</span>
              </div>
              <div className="contact-item">
                <HiOutlinePhone className="contact-icon" />
                <span>+54 11 4138-1800</span>
              </div>

              <div className="contact-buttons">
                {/* Telegram */}
                <div onClick={onClickTelegram} className="contact-button telegram-button">
                  <FaTelegram className="button-icon" />
                  <span>Unite a nuestro Telegram</span>
                </div>

                {/* WhatsApp */}
                <div onClick={onClickWhatsapp} className="contact-button whatsapp-button">
                  <FaWhatsapp className="button-icon" />
                  <span>Unite a nuestro canal</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sección Inferior */}
        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} Copyright:{" "}
            <span className="company-name">rocstar.tv syt.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
